import { TextInput as $TextInput } from '@mantine/core';
import type { TextInputProps as $TextInputProps } from '@mantine/core';
import { useController } from 'react-hook-form';
import type { FieldValues, UseControllerProps } from 'react-hook-form';

import { parseError } from './lib/parseError.ts';

type TextInputProps<T extends FieldValues> = UseControllerProps<T> & Omit<$TextInputProps, 'value' | 'defaultValue'>;

export function TextInput<T extends FieldValues>({
  name,
  control,
  defaultValue,
  rules,
  shouldUnregister,
  onChange,
  label,
  ...props
}: TextInputProps<T>) {
  const {
    field: { value, onChange: fieldOnChange, ref: _fieldRef, ...field },
    fieldState,
  } = useController<T>({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  return (
    <$TextInput
      error={parseError(label, fieldState.error)}
      label={label}
      value={value}
      onChange={(e) => {
        fieldOnChange(e);
        onChange?.(e);
      }}
      {...field}
      {...props}
    />
  );
}
